<template>
  <div class="service-terms-detail">
    <div v-if="content" v-html="content" class="content"></div>
    <div v-else class="empty">协议内容不存在</div>
  </div>
</template>

<script>
import { serviceTermsMap } from "../../data/serviceTerms";

export default {
  name: "ServiceTermsDetail",
  data() {
    return {
      content: ""
    };
  },
  watch: {
    $route: {
      immediate: true,
      handler() {
        this.loadContent();
      }
    }
  },
  methods: {
    loadContent() {
      const type = this.$route.params.type;
      const item = serviceTermsMap[type];
      if (!item) {
        this.content = "";
        document.title = "协议详情";
        return;
      }
      this.content = item.content;
      document.title = item.title;
    }
  }
};
</script>

<style scoped>
.service-terms-detail {
  background-color: #fff;
  min-height: 100vh;
  box-sizing: border-box;
  padding: 0.3rem 0.3rem 0.6rem;
}

.content {
  font-size: 0.28rem;
  color: #333;
  line-height: 1.7;
  word-break: break-word;
}

.content >>> .terms-title {
  font-size: 0.36rem;
  font-weight: bold;
  text-align: center;
  color: #282828;
  margin: 0.1rem 0 0.36rem;
  line-height: 1.4;
}

.content >>> .terms-heading {
  margin: 0.28rem 0 0.12rem;
  color: #282828;
  line-height: 1.6;
}

.content >>> .terms-p {
  margin: 0 0 0.2rem;
  text-align: justify;
}

.empty {
  padding: 1rem 0;
  text-align: center;
  color: #999;
  font-size: 0.28rem;
}
</style>
